import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cfac22 from 'js/library/utils/cfac22';

import placeholderThumbnail from 'styles/assets/placeholder/placeholder.gif';
import androidImg from 'styles/assets/Download/download_android.webp';
import IOS_img from 'styles/assets/Download/download_ios.webp';

import LoadingInfoClub from './LoadingInfoClub';
import ErrorMessageClubLinks from './ErrorMessageClubLinks';
import './styleClubLinks.css';

import { getSeuClube } from 'js/library/utils/API/getSeuClube';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import { LinktreePackage } from '@sysmobil/synoro-packages';

function ClubLinks() {
  const { t } = useTranslation('app');

  const { userInfo, loading: userInfoLoading } = useCurrentUserInfo();

  const [clubData, setClubData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isErrorApi, setIsErrorApi] = useState(false);
  const [message, setMessage] = useState('');
  const [loadingLogo, setLoadingLogo] = useState(false);

  useEffect(() => {
    const getClubInfo = async () => {
      try {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const clubeId = urlParams.get('id');

        if (!clubeId) {
          setIsErrorApi(true);
          setLoading(false);
          return;
        }

        if (!userInfo || !userInfo.uId) {
          setMessage('Usuário não autenticado.');
          setIsErrorApi(true);
          setLoading(false);
          return;
        }

        const club = await getSeuClube(userInfo.uId, clubeId);

        if (!club) {
          setMessage('Clube não encontrado.😢');
          setLoading(false);
          return;
        }

        if (!club.useFullLinks) {
          setMessage('Clube ainda não possui link. 😢');
        }

        setClubData(club);
        setLoading(false);
      } catch (error) {
        console.error('Erro geral:', error);
        setLoading(false);
        setIsErrorApi(true);
      }
    };

    if (!userInfoLoading) {
      getClubInfo();
    }
  }, [userInfo, userInfoLoading]);

  if (loading) {
    return <LoadingInfoClub />;
  } else if (!loading && isErrorApi) {
    return <ErrorMessageClubLinks />;
  }

  return (
    <div id="content-estab-links" className="container-estab-links background-img-esta-link">
      <header className="header-estab-links">
        <div className="header-content-estab-links">
          <span className="name-estab-links">{clubData?.name}</span>
        </div>
        <img
          className="img-estab-links"
          onLoad={() => setLoadingLogo(true)}
          src={
            loadingLogo
              ? cfac22('STORAGE_URL') + encodeURIComponent(clubData.logo) + '?alt=media'
              : placeholderThumbnail
          }
          alt="Foto do Clube"
        />
      </header>

      {message === '' ? (
        <main style={{ marginTop: '6rem' }}>
          <LinktreePackage
            ambient={cfac22('ambient')}
            links={clubData?.useFullLinks}
            socialMedia={clubData?.redesSociais}
            contact={clubData?.contatoTriibo}
          />
        </main>
      ) : (
        <h1 className="message-estab-links">{message}</h1>
      )}

      <footer className="footer-estab-links">
        <div className="warpper-footer-estb-links">
          <span>{t('general.download_triibo_app')}</span>
          <div className="wrapper-estab-links">
            <a href="https://triibo.page.link/TWAF" target="new">
              <img src={IOS_img} alt="IOS loja" />
            </a>
            <a href="https://triibo.page.link/1c84" target="new">
              <img src={androidImg} alt="Android loja" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ClubLinks;
